import { ConfigurationService, HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { Article } from '../../catalog.model';
import { ArticleEditorComponent } from '../article-editor/article-editor.component';
import { DialogService } from '@sdbn/appclient';
import { ArticleTypeService } from 'src/erp-articles/article-types/article-type.service';
import { SearchArticle, SearchArticleResult } from 'src/erp-articles/erp-common/erp-common.model';
import { importCostsPricesDialogComponent } from '../import-costsprice-dialog/import-costsprice-dialog.component';

@Component({
  selector: 'app-catalog-article-search',
  templateUrl: './catalog-article-search.component.html',
  styleUrls: ['./catalog-article-search.component.scss']
})
export class CatalogArticleSearchComponent implements OnInit {

  formGroup = new FormGroup({});

  query = '';

  includeArchivedArticles = false;

  priceScale = 2;

  items = new Array<SearchArticleResult>();

  downloadEnabled = true;

  constructor(
    private dialogService: DialogService,
    private articleTypeService: ArticleTypeService,
    public cps: ConfigurationService,
    public translationService: TranslationService,
    private http: HttpService
  ) {
    this.priceScale = this.cps.getClientParamValue('erp.use-three-digit-prices', 'false') === 'true' ? 3 : 2;

    this.formGroup.addControl('query', new FormControl('', []));
    this.formGroup.addControl('includeArchivedArticles', new FormControl(this.includeArchivedArticles, []));
  }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(formValues => {
      this.query = formValues.query;
      this.includeArchivedArticles = formValues.includeArchivedArticles === true;
    });
  }

  refreshArticleList() {
    console.log('search articles by query', this.query);

    this.http.postWithContext<SearchArticleResult[]>(environment.erpArticleEndpoint + '/searchArticle',
      new SearchArticle({ query: this.query, includeArchived: this.includeArchivedArticles }))
      .subscribe(response => {

        const data = new Array<SearchArticleResult>();

        for (const item of response) {
          data.push(new SearchArticleResult(item));
        }
        this.items = data;
      }, error => {
        console.log('error is', error);
      });
  }

  exportArticleList() {
    this.downloadEnabled = false;

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'catalog articles export');

    // keep focus in current window
    window.focus();

    this.http.postWithArraybufferResponse<any>(environment.erpArticleEndpoint + '/exportArticles', {}).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }
      this.downloadEnabled = true;

    }, error => {
      console.error(error);
      this.downloadEnabled = true;
    });
  }

  editArticle(item: SearchArticleResult) {
    this.http.postWithContext<Article>(environment.erpArticleEndpoint + '/getArticle', { id: item.id })
      .subscribe(value => {
        if (value != null) {
          const article = new Article(value);
          console.log('article received and converted', value, article);
          this.dialogService.openMaxHeight(ArticleEditorComponent, { articleType: this.articleTypeService.getById(article.articleTypeId), article: article }).afterClosed().subscribe(value => {
            if (value != null) {
              console.log('article is', value);
            }
          });
        }
      });
  }

  importCostsPrices() {

    this.dialogService.openDefault(importCostsPricesDialogComponent, {})
      .afterClosed();
  }

}
